import { Link } from 'react-router-dom';
import {
  Typography, Button as MuiButton, Stack, Grid,
} from '@mui/material';
import { baseUrl, newsUrl } from '@sda/utils/url';
import { PaddedDivider } from '@client/components/common/PaddedDivider';
import { Tip } from '@client/components/common/Tip';
import { useCreateShowCallLink } from '@client/hooks/useCreateShowCallLink';
import { ResponsiveStack } from '@client/components/common/ResponsiveStack';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SignupWrapper } from '../common/SignupWrapper';

const Explainer = () => {
  const isMobile = useIsMobile();
  const showCallProps = useCreateShowCallLink();

  return (
    <>
      <Stack spacing={2}>
        <Typography
          variant="h6"
          align="left"
          component="p"
        >
          Welcome to Side Door!
        </Typography>

        <Typography color="textSecondary">
          If you're ready to start looking for shows, create a
          {' '}

          <strong>Show Call</strong>
          .

          {isMobile ? ' ' : <br />}

          Otherwise, feel free to check out others' Show Calls in

          {' '}

          <strong>Connect</strong>
          .
        </Typography>

        <ResponsiveStack
          desktopSpacing={3}
          mobileSpacing={1.5}
        >
          <MuiButton
            id="sda-signup-artist-book-show-button"
            variant="contained"
            color="primary"
            size="large"
            component={Link}
            to="/myshows"
          >
            Book a Show
          </MuiButton>

          <MuiButton
            id="sda-signup-artist-create-show-call-button"
            {...showCallProps}
            variant="outlined"
            color="primary"
            size="large"
          >
            Create a Show Call
          </MuiButton>

          <MuiButton
            id="sda-signup-artist-connect-button"
            component={Link}
            to="/connect"
            variant="outlined"
            color="primary"
            size="large"
          >
            Browse Connect
          </MuiButton>
        </ResponsiveStack>
      </Stack>

      <PaddedDivider
        margin="large"
        extended
      />

      <Stack spacing={2}>
        <Typography variant="subtitle2">
          Resources for Getting Started
        </Typography>

        <div>
          <Grid
            spacing={1}
            container
          >
            <Grid item>
              <Tip
                id="sda-signup-artist-knowledge-base-tip"
                label="Link:"
                linkTo={baseUrl('/support/en/articles/7950676-artist-toolkit')}
                tipText="Artist Toolkit"
              />
            </Grid>

            <Grid item>
              <Tip
                id="sda-signup-artist-turn-gig-tip"
                label="News:"
                linkTo={newsUrl('/news/how-eric-kane-booked-his-own-tour-as-an-independent-musician')}
                tipText="How Eric Kane Booked His Own Tour as an Independent Musician"
              />
            </Grid>
          </Grid>
        </div>
      </Stack>
    </>
  );
};

export const Complete = () => (
  <SignupWrapper
    renderExplainer={<Explainer />}
    imgSrc={baseUrl('media/signup/sidedoorcrop-strombo.jpg')}
    imgTitle="The Sorority at House of Strombo. Photo: Lindsay Duncan."
  />
);
